import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  width: 320,
  backgroundColor: theme.palette.white,
  border: `1px solid ${theme.palette.fly.brandBorder}`,
  borderRadius: 12,
  boxShadow: theme.palette.fly.cardShadow,

  [theme.down("xl")]: {
    width: 270,
  },

  [theme.down("lg")]: {
    width: "100%",
  },
}));

export const FiltersButton = styled("button")(({ theme }) => ({
  position: "relative",
  borderRadius: "12px 12px 0 0",
  width: "100%",
  backgroundColor: theme.palette.button.primary,
  border: "none",
  color: theme.palette.text.white,
  margin: 0,
  height: 44,
  fontSize: 15,
  fontWeight: 600,
  cursor: "pointer",
  transition: "background-color .2s ease",

  "&:hover": {
    backgroundColor: theme.palette.button.primaryHover,
  },

  [theme.up("lg")]: {
    display: "none",
  },
}));

export const IconBlock = styled("span")(({ theme }) => ({
  position: "absolute",
  right: 12,
  top: 11,
  display: "flex",
  fontSize: 20,
  color: theme.palette.text.white,
  transform: "rotate(0deg)",
  transition: "all .3s ease",

  "&.active": {
    transform: "rotate(180deg)",
  },
}));

export const FiltersBlock = styled("div")(({ theme }) => ({
  height: "auto",
  overflow: "hidden",
  borderRadius: 12,

  [theme.down("lg")]: {
    height: 0,
    borderRadius: "0 0 12px 12px",

    "&.active": {
      height: "auto",
    },
  },
}));

// Заголовок виден всегда, чтобы блок не прыгал при появлении кнопки сброса.
// На мобильном заголовок уже есть на кнопке раскрытия, поэтому остаётся только сброс.
export const FiltersHeader = styled("div")(({ theme, $hasReset }) => ({
  ...theme.mixins.flexCenterBetween,
  gap: 12,
  padding: "16px 20px 0",

  [theme.down("lg")]: {
    display: $hasReset ? "flex" : "none",
    justifyContent: "flex-end",
  },
}));

export const FiltersTitle = styled("div")(({ theme }) => ({
  fontSize: 16,
  fontWeight: 600,

  [theme.down("lg")]: {
    display: "none",
  },
}));

export const ResetButton = styled("button")(() => ({
  border: "none",
  background: "transparent",
  color: "inherit",
  fontSize: 14,
  padding: 0,
  margin: 0,
  width: "auto",
  height: "auto",
  cursor: "pointer",
  textDecoration: "underline",

  "&:hover": {
    opacity: 0.7,
  },
}));
